module.exports = {
  baseURL: 'https://beta-nd-staging-panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://beta-nd-order.nidin.shop/',
  bdms: 'https://beta-nd-bdms.nidin.shop/',
  brand: 'nidin'
}



// WEBPACK FOOTER //
// ./src/assets/js/config-beta.js